module.exports = __webpack_public_path__ + "img/bg2.a7017a2f.webp";